import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { WorkShiftsDialog } from "./components/WorkShiftsDialog";
import WorkShiftsTable from "./components/WorkShiftsTable";
import { LoadingBox } from "../../../../../components/utils";

import { getWorkShifts, getWorkShift } from "../../../../services/pwsApi";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WorkShifts() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const companyCode = searchParams.get("company_code") ?? "";

  const workShiftId = searchParams.get("workshift_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const workShiftsQuery = useQuery(
    ["workshifts", companyCode, tablePageIndex, tablePageSize, searchQuery],
    () =>
      getWorkShifts(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        searchQuery,
        {
          mostrarFuncao: true,
          mostrarCentroCusto: true,
          page: tablePageIndex,
          perPage: tablePageSize,
        },
      ),
    {
      enabled: !!companyCode,
    },
  );

  const workShiftQuery = useQuery(
    ["workshift", workShiftId],
    () =>
      getWorkShift(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        workShiftId,
      ),
    {
      enabled: !!workShiftId,
      onSuccess: () => setDialogOpen(true),
    },
  );

  let workShift = workShiftQuery.data?.data ?? null;

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseWorkShiftDialog = () => {
    searchParams.delete("workshift_id");
    setSearchParams(searchParams);
    setDialogOpen(false);
  };

  const handleCreateWorkShift = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const workShifts = workShiftsQuery.data?.data?.data ?? [];
  const rows = workShiftsQuery.data?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <WorkShiftsDialog
          onClose={handleCloseWorkShiftDialog}
          data={workShift}
        />
      )}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Turnos de Trabalho
          </Typography>
        </Toolbar>
      </AppBar>

      <Backdrop className={classes.backdrop} open={workShiftsQuery.isLoading}>
        <LoadingBox />
      </Backdrop>

      <Box sx={{ height: "calc(100% - 94px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={e => searchDelayed(e.target.value)}
          />
        </Box>

        <WorkShiftsTable data={workShifts} rows={rows} />
      </Box>

      {/* <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateWorkShift}
      >
        <Add />
      </Fab> */}
    </Dialog>
  );
}
